document.querySelectorAll('[name="country"] option').forEach(function(option) {
  if (option.value === "---") {
    option.remove();
  }
});

jQuery('#sendDistributorForm').click(function() {
    if( jQuery('#conditions').is(':checked')  && jQuery('#email').val() != '' ){
      event.preventDefault();
      
      var form = jQuery('#formGeneratorForm');
      console.log('enviar form');
      var url = jQuery('#formGeneratorForm').attr('action');
    
      
      jQuery.ajax({
          type: "POST",
          url: url,
          data: form.serialize(),
          dataType  : "json",
          cache: false,
          success: function (data, status) {
            if (data.error != 1) {
              jQuery('#formGeneratorForm').hide();
              jQuery('#msgOK').removeClass('hidden');
               jQuery('#msgOK').show();
            }
          }
        
      });
    }else{
       
    }
    
    
});